import React, { useReducer, createContext } from 'react';
import reducers from './reducers';
import actionCreators from './actions';

//dumy data remember delete it
import { infoEmployess } from '../../routes/users/Employees/constants';
//dumy data remember delete it

const initialState = {
  employess: null,
  isSidebarRightOpen: false,
  selectedEmployee: null,
};

const reducer = (state = initialState, { type, payload }) => {
  return reducers[(payload.success && type) || 'ERROR'](state, payload);
};

export const context = createContext(initialState);

export default ({ children }) => {

  const [state, dispatch] = useReducer(reducer, initialState);

  const actions = actionCreators(state, dispatch);

  return <context.Provider
    value={{ state, actions }}>
    {children}
  </context.Provider>;
};
